export default __webpack_public_path__ + "b824d8a.png";